export const NotificationType = {
  IncidentCreated: 0,
  IncidentAssigned: 1,
  IncidentTeamAssigned: 2,
  IncidentStatusChanged: 3,
  IncidentResolved: 4,
  IncidentEscalated: 5,
  IncidentSlaBreached: 6,
  IncidentSlaWarning: 7,
  IncidentPriorityChanged: 8,
  IncidentMajorIncidentChanged: 9,
  IncidentCommentAdded: 10,
  DiscoveryJobStarted: 11,
  DiscoveryJobCompleted: 12,
  DiscoveryJobFailed: 13,
  DiscoveryJobCancelled: 14,
  OnCallAlert: 15,
  EscalationAlert: 16,
  OnCallShiftStarting: 18,
  OnCallShiftEnding: 19,
  TeamMemberAdded: 22,
  TeamMemberRemoved: 23,
  OnCallParticipantAdded: 24,
  OnCallParticipantRemoved: 25,
  UserRoleChanged: 26,
  AgreementReviewOverdue: 27,
  AiBudgetThresholdReached: 28,
} as const;

export type NotificationType = (typeof NotificationType)[keyof typeof NotificationType];

export interface Notification {
  id: string;
  type: NotificationType;
  title: string;
  message: string;
  sourceEntityType: string;
  sourceEntityId: string;
  isRead: boolean;
  readAt: string | null;
  createdAt: string;
  metadata: string | null;
}
